import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class TargetSourceAttributeLookupData {}
